import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type Language = {
  code: string;
  name: string;
};

export type FilterDetails = {
  languages: Language[];
  aboveMarketTeams: string[];
};

export type ClaimMetadataData = {
  filterDetails: FilterDetails[];
};

export type ClaimMetadata = {
  data: ClaimMetadataData;
  isLoading: boolean;
  hasNoData: boolean;
  errorMessage: string;
};

export const claimMetadataStateSegment = stateSegmentWithReset<ClaimMetadata>({
  data: {
    filterDetails: [],
  },
  isLoading: false,
  hasNoData: false,
  errorMessage: '',
});

claimMetadataStateSegment.debugLabel = 'claimMetadataStateSegment';
